/**
 * <csn-cart-timer> — Contador regressivo de "carrinho reservado".
 *
 * Mostra uma contagem MM:SS que persiste entre recarregamentos de página e
 * entre as atualizações do carrinho (o drawer é remontado via morph).
 * O tempo final é guardado em sessionStorage, então o contador continua
 * de onde parou em vez de reiniciar a cada mudança no carrinho.
 *
 * Uso (o Liquid injeta os atributos):
 *   <csn-cart-timer data-minutes="15" data-skip-node-update>
 *     <span data-timer-display>15:00</span>
 *   </csn-cart-timer>
 */
class CsnCartTimer extends HTMLElement {
  static STORAGE_KEY = 'csn-cart-timer-end';

  connectedCallback() {
    // Duração configurada no editor de temas (em minutos).
    this.minutes = parseFloat(this.dataset.minutes) || 15;
    this.display = this.querySelector('[data-timer-display]');

    this.#start();
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  /** Recupera (ou cria) o horário em que a reserva termina. */
  #getEndTime() {
    const stored = parseInt(sessionStorage.getItem(CsnCartTimer.STORAGE_KEY), 10);
    const now = Date.now();

    // Reinicia se não houver valor válido ou se o tempo já expirou.
    if (!stored || Number.isNaN(stored) || stored <= now) {
      const end = now + this.minutes * 60 * 1000;
      sessionStorage.setItem(CsnCartTimer.STORAGE_KEY, String(end));
      return end;
    }
    return stored;
  }

  #start() {
    this.#tick();
    // Atualiza a cada segundo.
    this.interval = setInterval(() => this.#tick(), 1000);
  }

  #tick() {
    const remaining = this.#getEndTime() - Date.now();

    if (remaining <= 0) {
      // Ao zerar, reinicia o ciclo para manter o senso de urgência.
      sessionStorage.removeItem(CsnCartTimer.STORAGE_KEY);
      return this.#tick();
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const mm = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
    const ss = String(totalSeconds % 60).padStart(2, '0');

    if (this.display) this.display.textContent = `${mm}:${ss}`;
  }
}

if (!customElements.get('csn-cart-timer')) {
  customElements.define('csn-cart-timer', CsnCartTimer);
}
